(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["procards-collection-shortcuts"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('pc-collection-shortcuts')) {
    customElements.define('pc-collection-shortcuts', class extends HTMLElement {
      connectedCallback() {
        this.lastQuery = location.pathname + location.search;
        this.sync = () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.refresh(), 100);
        };
        const grid = document.getElementById('ProductGridContainer');
        if (grid) {
          this.observer = new MutationObserver(this.sync);
          this.observer.observe(grid, { childList: true, subtree: true });
        }
        window.addEventListener('popstate', this.sync);
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.observer?.disconnect();
        this.controller?.abort();
        window.removeEventListener('popstate', this.sync);
      }
      async refresh() {
        const query = location.pathname + location.search;
        if (query === this.lastQuery) return;
        this.lastQuery = query;
        this.controller?.abort();
        this.controller = new AbortController();
        const url = new URL(location.href);
        url.searchParams.set('sections', this.dataset.sectionId);
        this.setAttribute('aria-busy', 'true');
        try {
          const response = await fetch(url, { signal: this.controller.signal });
          if (!response.ok) throw new Error('Section unavailable');
          const sections = await response.json();
          const html = sections[this.dataset.sectionId];
          if (!html) throw new Error('Section unavailable');
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('pc-collection-shortcuts');
          if (query !== location.pathname + location.search) return;
          if (!fresh) throw new Error('Section unavailable');
          this.innerHTML = fresh.innerHTML;
          this.hidden = false;
          this.removeAttribute('aria-busy');
        } catch (error) {
          if (error.name !== 'AbortError' && query === location.pathname + location.search) {
            this.hidden = true;
            this.removeAttribute('aria-busy');
          }
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["procards-promo-slider"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('pc-promo-slider'))customElements.define('pc-promo-slider',class extends HTMLElement{
    connectedCallback(){
      this.abort=new AbortController();this.track=this.querySelector('.pc-promo__track');this.slides=[...this.querySelectorAll('[data-promo-slide]')];this.index=0;this.paused=false;
      if(this.slides.length<2)return;
      const opts={signal:this.abort.signal};const controls=this.querySelector('.pc-promo__controls');controls.hidden=false;
      this.querySelector('[data-prev]').addEventListener('click',()=>this.move(-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>this.move(1),opts);
      this.track.addEventListener('scroll',()=>{this.index=Math.round(this.track.scrollLeft/this.track.clientWidth);this.querySelector('[data-counter]').textContent=(this.index+1)+' / '+this.slides.length;},{...opts,passive:true});
      this.toggle=this.querySelector('[data-toggle]');this.toggle?.addEventListener('click',()=>{this.paused=!this.paused;this.toggle.textContent=this.paused?this.dataset.play:this.dataset.pause;this.toggle.setAttribute('aria-pressed',String(this.paused));},opts);
      this.addEventListener('mouseenter',()=>this.hovered=true,opts);this.addEventListener('mouseleave',()=>this.hovered=false,opts);
      document.addEventListener('shopify:block:select',e=>{const slide=e.target.closest('[data-promo-slide]');if(slide&&this.contains(slide)){this.track.scrollTo({left:slide.offsetLeft,behavior:'instant'});this.paused=true;}},opts);
      if(this.dataset.autoplay==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches){this.timer=setInterval(()=>{if(!this.paused&&!this.hovered&&!this.contains(document.activeElement)&&!document.hidden){const r=this.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight)this.move(1);}},Number(this.dataset.interval)||8000);}
    }
    move(delta){this.index=(this.index+delta+this.slides.length)%this.slides.length;this.track.scrollTo({left:this.track.clientWidth*this.index,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});}
    disconnectedCallback(){this.abort?.abort();clearInterval(this.timer);}
  });

  } catch(e) { console.error(e); }
})();
})();
